export default {
  markAllAsRead: 'Oznacz wszystkie jako przeczytane',
};
